import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // ⬅️ Importação adicionada
import axios from "axios";
import "../styles/global.css";

const PublicarCheckpoint2 = () => {
  const { disciplina_id, turma_id } = useParams();
  const navigate = useNavigate(); // ⬅️ Instanciado aqui
  const [turma, setTurma] = useState(null);
  const [cursoNome, setCursoNome] = useState("");
  const [cursoCodigo, setCursoCodigo] = useState("");
  const [coordenadorNome, setCoordenadorNome] = useState("");
  const [coordenadorEmail, setCoordenadorEmail] = useState("");
  const [cursoModalidade, setCursoModalidade] = useState("");
  const [sessoes, setSessoes] = useState([]);
  const [sessaoSelecionada, setSessaoSelecionada] = useState("");
  const [disciplinaNome, setDisciplinaNome] = useState("");
  const [tempo, setTempo] = useState("");
  const [checkpoints, setCheckpoints] = useState([]);
  const [checkpointSelecionado, setCheckpointSelecionado] = useState("");

  useEffect(() => {
    const carregarDados = async () => {
      const cliente_id = localStorage.getItem("cliente_id");

      try {
        const turmaRes = await axios.get(`/api/turmas/${turma_id}`);
        const turmaData = turmaRes.data;
        setTurma(turmaData);
        setCursoCodigo(turmaData?.curso_codigo || "-");
        setCursoNome(turmaData?.curso_nome || "-");
        setCoordenadorNome(turmaData?.coordenador_nome || "-");
        setCoordenadorEmail(turmaData?.coordenador_email || "-");
        setCursoModalidade(turmaData?.curso_modalidade || "-");
      } catch (error) {
        console.error("Erro ao carregar turma:", error);
      }

      try {
        const sessoesRes = await axios.get(`/api/sessoes_aula/disciplina/${disciplina_id}`);
        setSessoes(sessoesRes.data);
      } catch (error) {
        console.error("Erro ao carregar sessões:", error);
      }

      try {
        const resDisc = await axios.get(`/api/disciplinas/${disciplina_id}`);
        setDisciplinaNome(resDisc.data.nome);
      } catch (err) {
        console.error("Erro ao carregar disciplina:", err);
      }

      try {
        const resCheck = await axios.get(`/api/checkpoints_autorizados/${cliente_id}`);
        setCheckpoints(resCheck.data);
      } catch (err) {
        console.error("Erro ao carregar checkpoints autorizados:", err);
      }
    };

    carregarDados();
  }, [turma_id, disciplina_id]);

  if (!turma) {
    return <div className="form-wrapper">Carregando dados da turma...</div>;
  }

  const handlePublicarCheckpoint = async () => {
    try {
      const cliente_id = localStorage.getItem("cliente_id");
      const user_id = localStorage.getItem("user_id");
      const curso_id = turma.curso_id;
  
      const payload = {
        cliente_id,
        usuario_id: user_id,
        curso_id,
        turma_id,
        disciplina_id,
        sessao_aula_id: sessaoSelecionada,
        checkpoint_autorizado_id: checkpointSelecionado,
        tempo_resposta: parseInt(tempo)
      };
  
      console.log("🔄 Enviando payload:", payload);
  
      await axios.post("/api/checkpoints_publicados", payload);
  
      console.log("✅ CheckPoint publicado com sucesso. Redirecionando...");
      navigate("/usuario/checkpoints");
  
    } catch (error) {
      console.error("❌ Erro ao publicar checkpoint:", error.response?.data || error.message);
      alert("Erro ao publicar checkpoint.");
    }
  };
  

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Publicar CheckPoint</h2>

      <div className="form-row">
        <div className="form-group" style={{ width: "200px" }}>
          <label>Cód. da Turma</label>
          <div className="campo-detalhe">{turma.codigo}</div>
        </div>
        <div className="form-group">
          <label>Nome da Turma</label>
          <div className="campo-detalhe">{turma.nome}</div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: "200px" }}>
          <label>Cód. do Curso</label>
          <div className="campo-detalhe">{cursoCodigo}</div>
        </div>
        <div className="form-group">
          <label>Nome do Curso</label>
          <div className="campo-detalhe">{cursoNome}</div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Coordenador</label>
          <div className="campo-detalhe">{coordenadorNome}</div>
        </div>
        <div className="form-group">
          <label>E-mail do Coordenador</label>
          <div className="campo-detalhe">
            <a href={`mailto:${coordenadorEmail}`} target="_blank" rel="noopener noreferrer">
              {coordenadorEmail}
            </a>
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: "220px" }}>
          <label>Modalidade do Curso</label>
          <div className="campo-detalhe">{cursoModalidade}</div>
        </div>
        <div className="form-group" style={{ width: "220px" }}>
          <label>Data de Início</label>
          <div className="campo-detalhe">
            {turma.data_inicio ? new Date(turma.data_inicio).toLocaleDateString() : ""}
          </div>
        </div>
        <div className="form-group" style={{ width: "220px" }}>
          <label>Data de Término</label>
          <div className="campo-detalhe">
            {turma.data_termino ? new Date(turma.data_termino).toLocaleDateString() : ""}
          </div>
        </div>
      </div>

      <div style={{ marginTop: "30px", fontWeight: "bold" }}>
        Disciplina: {disciplinaNome}
      </div>

      <div className="form-group full-width" style={{ marginTop: "15px" }}>
        <label>Sessão de Aula</label>
        <select
          value={sessaoSelecionada}
          onChange={(e) => setSessaoSelecionada(e.target.value)}
          className="form-control"
        >
          <option value="">-- Selecione --</option>
          {sessoes.map((sessao) => (
            <option key={sessao.id} value={sessao.id}>
              {sessao.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group full-width" style={{ marginTop: "15px" }}>
        <label>CheckPoint</label>
        <select
          value={checkpointSelecionado}
          onChange={(e) => setCheckpointSelecionado(e.target.value)}
          className="form-control"
        >
          <option value="">-- Selecione um CheckPoint --</option>
          {checkpoints.map((c) => (
            <option key={c.id} value={c.id}>
              {c.texto}
            </option>
          ))}
        </select>
      </div>

      <div className="form-row" style={{ alignItems: "center", marginTop: "30px" }}>
        <label htmlFor="tempo" style={{ marginRight: "10px", whiteSpace: "nowrap" }}>
          Tempo de Resposta (em minutos):
        </label>
        <input
          type="number"
          id="tempo"
          className="form-control"
          style={{ width: "100px", marginRight: "10px" }}
          min="1"
          placeholder="Ex: 10"
          value={tempo}
          onChange={(e) => setTempo(e.target.value)}
        />
        <button
          className="btn btn-primary"
          disabled={!sessaoSelecionada || !tempo || !checkpointSelecionado}
          onClick={handlePublicarCheckpoint}
        >
          Publicar Checkpoint
        </button>
      </div>
    </div>
  );
};

export default PublicarCheckpoint2;



